const SERVER_SENT_EVENT_KEY = "dental21-server-sent-event";
export {
  SERVER_SENT_EVENT_KEY
};
